"use client";

import React from "react";

export const Desktop = () => {
    return (
        <main className="">
            <div>
                <h1 className="font-medium text-[24px] leading-[27px] tracking-[0] mb-[25px]">Politika zasebnosti</h1>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                Nazadnje posodobljeno: 21. oktober 2026
                </p>
                
                <div className="flex flex-col gap-y-8 text-[16px] leading-[27px] font-light">
                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">1. Uvodne določbe</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Ta politika zasebnosti opisuje, kako Aleja 8, Saša Dolinšek s.p., Trg svobode 32, 1420 Trbovlje kot upravljavec osebnih podatkov obdeluje osebne podatke uporabnikov v zvezi z uporabo spletne strani{" "}
                        </p>
                        <p>www.osmrtnica.com.</p>
                        <p>
                            Politika zasebnosti velja za vse uporabnike Spletne strani, ne glede na to, ali dostopajo kot registrirani uporabniki ali kot obiskovalci.</p>
                        <p>
                            Politika je skladna z GDPR in Zakonom o varstvu osebnih podatkov (ZVOP-2).</p>
                        <p>
                            Kontakt upravljavca: info@osmrtnica.com.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">2. Vrste osebnih podatkov</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">Upravljavec zbira in obdeluje naslednje osebne podatke:</p>
                        <ul className="list-disc marker:text-gray-400 pl-5">
                            <li>
                                podatki ob registraciji: ime, priimek, e-naslov, geslo, podatki podjetja (če gre za poslovni račun),
                            </li>
                            <li>
                                podatki, ki jih uporabniki vnesejo ob objavi vsebin (osmrtnice, sožalja, žalne knjige, virtualne svečke, sožalja, zgodbe, fotografije in druge vsebine na spominski strani),
                            </li>
                            <li>
                                podatki o pokojnikih (ime, priimek, datum rojstva in smrti, fotografija, biografski zapisi),
                            </li>
                            <li>
                                podatki o uporabi spletne strani (IP-naslovi, podatki o napravah, brskalnikih, datum in ura dostopa, zgodovina iskanja znotraj strani),
                            </li>
                            <li>
                                podatki podjetij (ime podjetja, naziv cvetličarne ali pogrebne enote, elektronski naslov, naslov, sedež),
                            </li>
                            <li>
                                podatki o plačilu (ime in naslov za račun, naziv podjetja in davčna številka, če jih navedete); številk plačilnih kartic ne hranimo, plačilo obdela ponudnik plačilnih storitev,
                            </li>
                            <li>
                                dokumenti, ki jih Skrbnik naloži za potrditev (npr. smrtovnica ali drug dokument o smrti); shranjeni so zasebno in niso javno dostopni,
                            </li>
                            <li>
                                ime in e-naslov iz Google računa, če se prijavite z njim,
                            </li>
                            <li>
                                fotografije in druge datoteke, ki jih uporabniki naložijo na spominske strani; te so lahko javne ali zasebne (dostopne samo preko gesla).
                            </li>
                        </ul>
                    </section>

                    <section className="">
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">3. Namen obdelave</h2>
                        <ul className="list-disc marker:text-gray-400 pl-5">
                            <li>
                                zagotavljanje storitev Spletne strani (objava osmrtnic, sožalij, vpisov na spominske strani, na sezname podjetij),
                            </li>
                            <li>upravljanje registracije in uporabniških računov,</li>
                            <li>
                                omogočanje registracije podjetjem (cvetličarne, pogrebna podjetja) za objavo svojih vsebin in ponudb,
                            </li>
                            <li>omogočanje objave in upravljanja oglaševalskih vsebin</li>
                            <li>omogočanje prikazovanja lokalnih vsebin</li>
                            <li>
                                obveščanje uporabnikov o novostih in spremembah v zvezi s storitvami,
                            </li>
                            <li>
                                zagotavljanje varnosti Spletne strani, preprečevanja zlorab in odkrivanja nepooblaščenih dostopov,
                            </li>
                            <li>izpolnjevanja zakonskih obveznosti upravljavca.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">4. Pravna podlaga</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">Pravna podlaga za obdelavo osebnih podatkov temelji na:</p>
                        <ul className="list-disc marker:text-gray-400 pl-5">
                            <li>privolitvi posameznika (ob registraciji in uporabi določenih storitev),</li>
                            <li>
                                pogodbenem razmerju med uporabnikom in upravljavcem (npr. ob sklenitvi naročnine ali objavi osmrtnice),
                            </li>
                            <li>
                                zakonitem interesu upravljavca (zagotavljanje delovanja in varnosti spletne strani, preprečevanje zlorab, anonimna statistika obiska, izboljšanje uporabniške izkušnje),
                            </li>
                            <li>izpolnjevanju zakonskih obveznosti, ki veljajo za upravljavca.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] ">5. Hramba osebnih podatkov</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Osebni podatki se hranijo toliko časa, kolikor je nujno potrebno za dosego namenov, zaradi katerih so bili zbrani
                        </p>
                        <ul className="list-disc marker:text-gray-400 pl-5">
                            <li>
                                Podatki, ki jih vnesejo uporabniki ob objavi osmrtnic, sožalij, zapisov v žalnih knjigah in podobnih vsebin, se hranijo trajno, saj so namenjeni javni objavi in ohranjanju spomina.
                            </li>
                            <li>
                                Podatki, zbrani na podlagi privolitve, se hranijo do preklica privolitve.
                                <ul className="">
                                    <li>- osebni podatki ob registraciji: do izbrisa računa,</li>
                                    <li>- spominske vsebine: trajno, razen če se zahteva izbris,</li>
                                    <li>- tehnični podatki (IP naslovi in dnevniki dostopov): do 90 dni.</li>
                                </ul>
                            </li>
                            <li>
                                Podatki o plačilih in izdanih računih se hranijo 10 let, kot to predpisuje davčna zakonodaja.
                            </li>
                            <li>
                                Dokumenti, ki jih Skrbnik naloži za potrditev (npr. smrtovnica), se hranijo še eno leto po prenehanju statusa skrbnika; uporabnik lahko kadarkoli zahteva predčasen izbris.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] ">6. Pravice uporabnikov</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">Uporabniki imajo pravico:</p>
                        <ul className="list-disc marker:text-gray-400 pl-5">
                            <li>dostopati do svojih osebnih podatkov,</li>
                            <li>zahtevati popravek netočnih ali nepopolnih podatkov,</li>
                            <li>zahtevati omejitev obdelave,</li>
                            <li>zahtevati izbris osebnih podatkov (razen kadar hramba temelji na zakonu),</li>
                            <li>
                                vložiti ugovor zoper obdelavo podatkov, kadar se obdelava izvaja na podlagi zakonitega interesa,
                            </li>
                            <li>prenesti osebne podatke k drugemu upravljavcu,</li>
                            <li>kadar koli preklicati privolitev (preklic ne vpliva na zakonitost obdelave pred preklicem).</li>
                        </ul>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Uporabniki lahko svoje pravice uveljavljajo s pisno zahtevo na info@osmrtnica.com. Če menite, da je obdelava nezakonita, lahko vložite pritožbo pri Informacijskem pooblaščencu (www.ip-rs.si).
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">7. Posredovanje osebnih podatkov tretjim osebam</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec osebnih podatkov ne posreduje tretjim osebam, razen če to zahtevajo veljavna zakonodaja, sodne odločbe ali če je to nujno za izvajanje storitev (npr. ponudnikom gostovanja strežnikov, vzdrževanja informacijskih sistemov, pravnim ali računovodskim svetovalcem). Vsi pogodbeni obdelovalci osebnih podatkov so zavezani k spoštovanju veljavne zakonodaje o varstvu podatkov in te Politike zasebnosti.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Za izvajanje storitev uporabljamo tudi ponudnike plačilnih storitev, pošiljanja e-pošte in prijave z Google računom. Ti ponudniki lahko podatke obdelujejo tudi zunaj Evropskega gospodarskega prostora; prenos poteka na podlagi sklepa o ustreznosti ali standardnih pogodbenih klavzul.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">8. Uporaba piškotkov in podobnih tehnologij</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Spletna stran uporablja samo piškotke, ki so nujni za prijavo in varno delovanje strani. Podrobne informacije so dostopne v posebnem dokumentu »Politika piškotkov«.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">9. Uporaba storitve Umami (spletna analitika)</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Za spremljanje obiska in uporabe Spletne strani uporabljamo storitev Umami, ki deluje brez piškotkov in ne ustvarja profila posameznega obiskovalca. Podatki se zbirajo v anonimizirani obliki (IP naslov se pretvori v nevrnljivo obliko), zato posameznega obiskovalca na njihovi podlagi ni mogoče prepoznati.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                            Pri uporabi te storitve se lahko obdelujejo: anonimizirani podatki o povezavi, obiskana stran, informacije o brskalniku in napravi ter vir obiska (npr. iskalnik ali spletna stran, s katere je uporabnik prišel). Ker Umami ne uporablja piškotkov in ne sledi uporabniku med obiski, za to obdelavo soglasje ni potrebno.
                        </p>
                   </section>
                    
                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">10. Uporaba storitve bunny.net</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Za delovanje in optimizacijo naše spletne strani uporabljamo storitve ponudnika bunny.net (BunnyWay, informacijske storitve d.o.o., Dunajska cesta 165, 1000 Ljubljana, Slovenija).
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">bunny.net deluje kot pogodbeni obdelovalec podatkov v skladu z 28. členom GDPR.</p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">Pri uporabi njihovih storitev se lahko obdelujejo naslednji osebni podatki:</p>
                        <ul className="list-disc marker:text-gray-400 pl-5 mb-6">
                            <li>IP naslovi in podatki o povezavi,</li>
                            <li>informacije o uporabnikovem brskalniku (User-Agent),</li>
                            <li>URL naslov strani, s katere je uporabnik prišel (referrer),</li>
                            <li>tehnični podatki potrebni za dostavo in varnost vsebine.</li>
                        </ul>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0] ">
                            Obdelava se izvaja izključno za namen zagotavljanja varnega in hitrega delovanja spletne strani, preprečevanja zlorab, ter optimizacije dostave vsebin.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0] ">
                            Z bunny.net imamo sklenjen Data Processing Agreement (DPA), ki zagotavlja varovanje osebnih podatkov v skladu z zahtevami GDPR. Več o obdelavi podatkov pri bunny.net si lahko preberete tukaj:
                        </p>
                        <a href="https://bunny.net/gdpr/" className="underline underline-offset-4">https://bunny.net/gdpr/</a>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">11. Javnost vsebin</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Uporabniki se morajo zavedati, da so vsebine, ki jih vnesejo na spletno stran (osmrtnice, spominske strani, sožalja, zapisi v žalnih knjigah, prižgane svečke ipd.), javno dostopne vsem obiskovalcem, razen spominskih strani, ki jih Skrbnik zaščiti z geslom.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec ne more zagotoviti, da tretje osebe teh podatkov ne bodo shranjevale, delile ali uporabljale na način, na katerega nima vpliva.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">12. Spremembe Politike zasebnosti</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec si pridržuje pravico, da Politiko zasebnosti kadarkoli spremeni ali dopolni. Vse spremembe začnejo veljati z dnem objave na spletni strani. Veljavna različica je vedno objavljena na tej strani.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">13. Moderiranje in pravica do izbrisa vsebin</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Ker so objavljene vsebine javnega značaja, upravljavec skrbi za dostojanstvo in spoštljivost. Upravljavec lahko brez predhodnega obvestila izbriše vsebine, ki so žaljive, politične, komercialne, sovražne ali na kakršen koli način neprimerne.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Na zahtevo svojcev ima upravljavec pravico izbrisati sporne vsebine ali celotno spominsko stran.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">14. Obdelava podatkov za namen varnosti</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Poleg podatkov, ki jih vnesejo uporabniki, upravljavec obdeluje tudi tehnične podatke (IP naslove, dnevnike dostopov, podatke o napravah) z namenom preprečevanja zlorab, zaščite pred vdori in zagotavljanja varnega delovanja spletne strani. Ti podatki se hranijo do 90 dni, razen če je daljša hramba nujna za obravnavo varnostnega incidenta.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">15. Posebne določbe glede podatkov o pokojnih osebah</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Podatki in vsebine, ki se nanašajo na pokojne osebe (ime, priimek, datum rojstva in smrti, fotografije, biografski zapisi), se obdelujejo na podlagi vnosa uporabnikov in se objavljajo z namenom obveščanja in ohranjanja spomina.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec ne preverja točnosti ali avtentičnosti podatkov, si pa pridržuje pravico, da ob prejemu pritožbe takšne podatke odstrani.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">16. Pravica do pozabe in omejitve obdelave</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Posamezniki lahko zahtevajo izbris osebnih podatkov, razen kadar to ni skladno z zakonodajo ali kadar prevlada javni interes (npr. ohranjanje zgodovinskega spomina).
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Pri podatkih o pokojnih osebah si upravljavec pridržuje pravico presojati med javnim interesom in pravicami svojcev.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">17. Odgovornost uporabnikov za podatke tretjih oseb</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Če uporabnik vnese osebne podatke tretjih oseb (npr. svojcev, podpisnikov sožalij), je sam odgovoren, da ima za to ustrezno pravno podlago oziroma privolitev.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec ne odgovarja za primere, ko uporabnik vnese podatke brez soglasja, vendar si pridržuje pravico odstraniti takšne podatke na zahtevo posameznika.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec si pridržuje pravico, da občasno sam objavi osmrtnice, pri čemer se poslužuje javnih virov.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">18. Izključitev odgovornosti</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec si prizadeva zagotavljati točnost in ažurnost podatkov, objavljenih na spletni strani, vendar ne jamči za njihovo popolnost, točnost ali ažurnost, zlasti kadar podatke vnesejo uporabniki ali so pridobljeni iz javno dostopnih virov.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec ne odgovarja za škodo, nastalo zaradi napačnih, nepopolnih ali neažurnih podatkov, razen v primerih, ko odgovornosti ni mogoče izključiti v skladu z veljavno zakonodajo.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Če uporabnik ali druga oseba opozori na netočne podatke, bo upravljavec opozorilo ustrezno obravnaval in po potrebi podatke popravil ali odstranil.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">19. Pridobivanje osebnih podatkov iz javno dostopnih virov</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Upravljavec lahko v okviru delovanja spletne strani pridobiva določene podatke o pokojnih osebah iz javno dostopnih virov, kadar je to potrebno za objavo osmrtnic in obveščanje javnosti. Pri tem lahko obdeluje podatke, kot so ime in priimek pokojne osebe, datum rojstva in smrti ter druge javno objavljene informacije, povezane z osmrtnico.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Podatki se obdelujejo za namen obveščanja javnosti in ohranjanja spomina na pokojne osebe. Upravljavec pri tem upošteva veljavno zakonodajo o varstvu osebnih podatkov in si pridržuje pravico, da ob utemeljenem ugovoru ali zahtevi pojasni vir podatkov ter preveri možnosti njihovega popravka ali odstranitve.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">20. Končne določbe</h2>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Ta Politika zasebnosti se uporablja od dneva objave na spletni strani www.osmrtnica.com in velja do objave njene nove različice.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Za vsa vprašanja, povezana z obdelavo osebnih podatkov, lahko uporabniki kontaktirajo upravljavca na elektronskem naslovu info@osmrtnica.com.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Za vprašanja, ki jih ta politika izrecno ne ureja, se uporabljajo določbe Splošne uredbe o varstvu podatkov (GDPR), Zakona o varstvu osebnih podatkov (ZVOP-2) in druge veljavne zakonodaje Republike Slovenije ter Evropske unije.
                        </p>
                        <p className="font-light text-[16px] leading-[27px] tracking-[0] mt-6">
                            Trbovlje, 21. 10. 2026, osmrtnica.com
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
};
